module.exports = __webpack_public_path__ + "static/media/Checklist.6a173684.png";